"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Overlay = void 0;
var _react = _interopRequireWildcard(require("react"));
var _bricksUtils = require("@titelmedia/bricks-utils");
var _styles = require("./styles");
var _breakpoints = require("@titelmedia/bricks-theme/lib/variables/breakpoints");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const Overlay = ({
  items,
  staticImage,
  staticPosition,
  overlayHorizontal,
  overlayVertical,
  overlayAlignment,
  enableAnimation,
  setAnimationDuration
}) => {
  const wrapperRef = (0, _react.useRef)(null);
  const imageContainer = (0, _react.useRef)(null);
  const overlayRef = (0, _react.useRef)(null);
  const fluid = staticImage?.fluid || staticImage?.responsiveImage || staticImage;
  overlayHorizontal = overlayHorizontal || 'center';
  overlayVertical = overlayVertical || 'bottom';
  const isAnimationEnable = enableAnimation === 'true' || enableAnimation === true;
  (0, _react.useEffect)(() => {
    if (wrapperRef.current) {
      const elements = overlayRef.current.querySelectorAll('img');
      const mm = _bricksUtils.gsap.matchMedia();
      mm.add(`(min-width: ${_breakpoints.BREAKPOINTS.sm}px)`, () => {
        _bricksUtils.gsap.set(elements, {
          y: 100,
          opacity: 0
        });
        _bricksUtils.gsap.to(wrapperRef.current, {
          scrollTrigger: {
            trigger: wrapperRef.current,
            start: 'top top',
            end: `+=${imageContainer.current.offsetHeight * 3}`,
            pin: true
          }
        });
        _bricksUtils.ScrollTrigger.batch(elements, {
          trigger: wrapperRef.current,
          start: 'top top',
          end: `+=${imageContainer.current.offsetHeight * 2}`,
          batchMax: 1,
          onEnter: batch => _bricksUtils.gsap.to(batch, {
            y: 0,
            opacity: 1,
            stagger: 0.5,
            delay: 1,
            overwrite: 'auto'
          })
        });
      });
      if (isAnimationEnable) {
        _bricksUtils.gsap.effects.fade(wrapperRef.current, {
          duration: setAnimationDuration ? setAnimationDuration : 0.75,
          trigger: wrapperRef.current
        });
      }
    }
  }, []);
  return _react.default.createElement(_styles.Wrapper, {
    ref: wrapperRef
  }, _react.default.createElement(_styles.ContainerWrapper, {
    staticPosition: staticPosition
  }, fluid && _react.default.createElement(_styles.ImageContainer, {
    ref: imageContainer,
    aspectRatio: fluid.aspectRatio
  }, _react.default.createElement(_styles.Image, {
    src: fluid.src
  })), _react.default.createElement(_styles.WrapperOverlay, {
    overlayHorizontal: overlayHorizontal,
    overlayVertical: overlayVertical
  }, _react.default.createElement(_styles.OverlayContainer, {
    ref: overlayRef,
    overlayAlignment: overlayAlignment
  }, items?.map((item, i) => {
    return _react.default.createElement(_styles.ImageItem, {
      key: `item-${i}`,
      src: item.src,
      srcSet: item.srcSet,
      alt: item.src,
      aspectRatio: item.aspectRatio
    });
  })))));
};
exports.Overlay = Overlay;
//# sourceMappingURL=index.js.map